<div *ngIf="!isExternalBlockingAlertVisible" class="datepicker__container">
  <div *ngFor="let day of weekData" class="datepicker__week">
    <div class="datepicker__header">
      <div class="dayname">{{ day.dayname }}</div>
      <div class="day">{{ day.day }}</div>
      <div class="today">
        <div *ngIf="isToday(day)" class="today__dot"></div>
      </div>
    </div>
    <div
      (click)="selectTime(day.date, time)"
      *ngFor="let time of day.times"
      class="datepicker__time"
    >
      <div class="datepicker__time--content">{{ time }}</div>
    </div>
  </div>
</div>
<div
  *ngIf="isAlertVisible === true"
  class="mx-auto mt-4 max-w-prose rounded-xl bg-warning py-6 px-4 text-center text-sm text-apricot-1"
>
  Det finns inga lediga tider denna vecka.
</div>
